import { isCastBet, isTeaserBet, isYourBet, isComboBet, isSystemBet } from "../../../common";
import { getSelectionTitleBulletCastProps, getSelectionTitleBulletEWProps } from "../../selection";
export const getSelectionTitleBulletProps = (selection, betType, state, isEachWay) => {
    if (isYourBet(betType) || isTeaserBet(betType)) {
        return {
            name: selection.selectionDisplayName,
            status: selection.settlementStatus,
            market: selection.marketDisplayName
        };
    }
    if (isCastBet(betType)) {
        return getSelectionTitleBulletCastProps(selection, state);
    }
    if (isComboBet(betType) || isSystemBet(betType)) {
        return getSelectionTitleBulletEWProps(selection, state, isEachWay);
    }
    return {
        name: selection.selectionDisplayName,
        status: selection.settlementStatus,
        odds: selection.displayOdds
    };
};
//# sourceMappingURL=getSelectionTitleBulletProps.js.map